var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"dashboard"}},[_c('Navbar'),_vm._v(" "),(_vm.mode == null)?_c('DashboardHome'):_vm._e(),_vm._v(" "),(_vm.mode == 'settings')?_c('DashboardSettings'):_vm._e(),_vm._v(" "),(_vm.mode == 'exploration-settings')?_c('ExplorationSettings'):_vm._e(),_vm._v(" "),(_vm.mode == 'edit-exploration')?_c('EditExploration'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69203a46","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard.vue
// module id = null
// module chunks = 